import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProCardComponent } from './pro-card.component';
import { ButtonModule } from '../../atoms/button/button.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ProCardComponent],
  exports: [ProCardComponent],
  imports: [CommonModule, ButtonModule, RouterModule],
})
export class ProCardModule {}
